import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { useNavigate } from 'react-router-dom';

export default function Success() {

    const navigate = useNavigate();

    useEffect(
        () => {
          let timer1 = setTimeout(() => navigate('/'), 10000);
    
          // this will clear Timeout
          // when component unmount like in willComponentUnmount
          // and show will not change to true
          return () => {
            clearTimeout(timer1);
          };
        },
        // useEffect will run only one time with empty []
        // if you pass a value to array,
        // like this - [data]
        // than clearTimeout will run every time
        // this value changes (useEffect re-run)
        []
      );

    return (
        <Box sx={{  height: 'calc(100vh - 100px)', bgcolor: 'error.main', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', alignContent: 'center'  }} >
            <ErrorIcon sx={{ height: '120px', width: '120px', color: '#FFF' }} />
            <Box sx={{ typography: 'h6', color: 'white' }}>An error has occured.</Box>
            <Box sx={{ typography: 'h6', color: 'white' }}>Please try again later.</Box>

            
        </Box>
    )
}